// Mobile buy bar: revealed once the main add-to-cart button scrolls out of view, hidden again near the footer.
class StickyBuyBar extends HTMLElement {
  #observer = null;
  #mainVisible = true;
  #mainAbove = false;
  #footerVisible = false;

  connectedCallback() {
    const form = this.closest('form');
    const main = form?.querySelector('[data-main-add]');
    const footer = document.querySelector('footer');
    if (!main) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === main) {
          this.#mainVisible = entry.isIntersecting;
          this.#mainAbove = entry.boundingClientRect.top < 0;
        } else {
          this.#footerVisible = entry.isIntersecting;
        }
      }
      this.#update();
    });
    this.#observer.observe(main);
    if (footer) this.#observer.observe(footer);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #update() {
    const show = !this.#mainVisible && this.#mainAbove && !this.#footerVisible;
    this.toggleAttribute('data-visible', show);
    this.toggleAttribute('inert', !show);
    this.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
}

if (!customElements.get('s-sticky-buy-bar')) {
  customElements.define('s-sticky-buy-bar', StickyBuyBar);
}
